import { navItems, keywords } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <>
      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20open%20sky%20at%20golden%20hour%20with%20soft%20amber%20and%20coral%20clouds%20and%20a%20flock%20of%20birds%20flying%2C%20stylized%20painterly%20illustration%2C%20warm%20hopeful%20atmosphere%2C%20clean%20composition%20with%20empty%20space%20for%20text&width=1920&height=900&seq=cta-sky-birds-2026&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-accent-950/60" />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-background-50">
            准备好开始这段热血又搞笑的补番之旅了吗
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-sm md:text-base text-background-100/85 leading-relaxed">
            先复制作品名，再到你常用的渠道里搜索；不确定顺序就回到补番指南，按篇章一步步来。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-circle-line text-lg" />
              获取观看渠道
            </a>
            <a
              href="#order"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-sm md:text-base whitespace-nowrap hover:bg-background-100 transition-colors"
            >
              <i className="ri-route-line text-lg" />
              查看补番顺序
            </a>
          </div>
        </div>
      </section>

      <footer className="w-full bg-primary-950 text-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="md:col-span-1">
              <div className="flex items-center gap-2">
                <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center font-heading text-lg">
                  家
                </span>
                <span className="font-heading text-lg text-background-50">我的家庭教师</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-background-200/80">
                一个面向《我的家庭教师》（家庭教师HITMAN REBORN!）爱好者的内容整理页面，
                汇总作品信息、角色设定、篇章导览与观看渠道说明，帮助你更顺畅地补番与重温。
              </p>
            </div>

            <div>
              <h3 className="font-label text-sm text-background-50">页面导航</h3>
              <ul className="mt-4 grid grid-cols-2 gap-2.5">
                {navItems.map((n) => (
                  <li key={n.id}>
                    <a
                      href={`#${n.id}`}
                      className="text-sm text-background-200/80 hover:text-primary-200 transition-colors"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-label text-sm text-background-50">相关检索词</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {keywords.map((k) => (
                  <span
                    key={k}
                    className="px-2.5 py-1 rounded-full text-xs bg-background-50/10 text-background-200/90"
                  >
                    {k}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-300/70">
              © {new Date().getFullYear()} 我的家庭教师 · 番剧信息与观看渠道索引页面
            </p>
            <p className="text-xs text-background-300/70 text-center sm:text-right">
              本站为动漫爱好者信息整理页面，不代表任何官方立场，请优先选择正版渠道观看。
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}